import 'idempotent-babel-polyfill';
import alt from '../../alt';
import ChangePasswordActions from './ChangePasswordActions';

class ChangePasswordStore {
    constructor() {
        this.state = {
            currentPassword: '',
            password: '',
            confirmPassword: '',
            finished: false,
            validPassword: false,
            passwordExists: false
        };

        this.bindListeners({
            fieldChanged: ChangePasswordActions.CHANGE_FIELD,
            handleSubmitSuccess: ChangePasswordActions.SUBMIT_SUCCESS,
            reset: ChangePasswordActions.RESET,
            returnPasswordRequirements: ChangePasswordActions.VALIDATE_PASSWORD_REQUIREMENTS_SUCCESS
        });
    }

    fieldChanged(diff) {
      this.setState(diff);
    }

    handleSubmitSuccess(result) {
      this.setState({ finished: true });
    }

    reset() {
      this.setState({
        currentPassword: '',
        password: '',
        confirmPassword: '',
        finished: false,
        validPassword: false,
        passwordExists: false
      });
    }

    returnPasswordRequirements(hasRecord) {
        this.setState({
            passwordExists: typeof hasRecord === "boolean" ? !hasRecord : true,
            validPassword: typeof hasRecord === "boolean" ? hasRecord : false
        })
    }
}

export default alt.createStore(ChangePasswordStore, 'ChangePasswordStore');



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/ChangePassword/ChangePasswordStore.js